import request from '@front-end/utils/lib/request'

export const getList = () => {
  return request({
    withCredentials: true,
    url: 'https://common-open-api.jin10.com/configuration/getById',
    method: 'GET',
    params: { id: 1110 },
    headers: {
      'x-version': '1.0.0',
      'x-app-id': 'zP6WFH7WKz2vrw4Q'
    }
  })
}
